<template>
  <div>
    <table class="table is-fullwidth is-striped">
      <thead></thead>
      <tbody>
        <tr>
          <th width="25%">{{ $t("devices.deviceId") }}</th>
          <td>{{ device.deviceId }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.deviceType") }}</th>
          <td>{{ device.deviceType }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.deviceLocate") }}</th>
          <td>{{ device.deviceLocate }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.address") }}</th>
          <td>{{ device.address }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.antenna") }}</th>
          <td>
            {{ device.antenna }}
            <span v-if="device.antennaRawData != ''">({{ device.antennaRawData }})</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t("devices.ipAddress") }}</th>
          <td>{{ device.ipAddress }}</td>
        </tr>
        <tr>
          <th>{{ $t("devices.heartBeat") }}</th>
          <td>
            {{ device.heartBeatUpdateTime }}
          </td>
        </tr>
        <tr>
          <th>{{ $t("devices.Survey") }}</th>
          <td>
            {{ $t("devices.survey.q1_is_people") }} -->
            <span v-if="device.q1People == 'true'">{{ $t("devices.survey.yes") }}</span>
            <span v-else-if="device.q1People == 'false'">{{ $t("devices.survey.no") }}</span>
            <span v-else>{{ $t("devices.survey.unknown") }}</span
            ><br />
            {{ $t("devices.survey.q2_is_hotbg") }} -->
            <span v-if="device.q2Hotbg == 'true'">{{ $t("devices.survey.yes") }}</span>
            <span v-else-if="device.q2Hotbg == 'false'">{{ $t("devices.survey.no") }}</span>
            <span v-else>{{ $t("devices.survey.unknown") }}</span
            ><br />
            {{ $t("devices.survey.q3_range") }} -->
            <span v-if="device.q3Range == '2'">{{ $t("devices.survey.unknown") }}</span>
            <span v-else>{{ device.q3Range }}</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t("Created_at") }}</th>
          <td>{{ device.created_at }}</td>
        </tr>
        <tr>
          <th>{{ $t("Updated_at") }}</th>
          <td>{{ device.updated_at }}</td>
        </tr>
        <tr>
          <th>{{ $t("Note") }}</th>
          <td>{{ device.note }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    device: {
      type: Object,
      require: true,
    },
  },
};
</script>
